import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { GamSetupOrderSliceDTO } from './types'

export const GAM_SETUP_ORDER_FRAGMENT: TypedDocumentNode<GamSetupOrderSliceDTO> = gql`
  fragment GamSetupOrderFragment on GamSetupOrder {
    bannerTemplateId
    duration
    errorMessage
    id
    instreamEnabled
    jsdelivrEnabled
    nativeEnabled
    nativeTemplateId
    setupType
    status
    updatedAt
    vastUrl
  }
`
